import { apiFetch } from "@/integrations/backend/client";
import { ApiRequestError } from "@/lib/api-request-error";

export type GptLogDetailPayload = {
  id: string;
  messages: unknown;
  output: string;
  cleaned_output: string;
  request_failed: boolean;
  model: string;
  temperature: number;
  max_tokens: number;
  provider: string;
  model_type: string;
  type: string;
  preset_label: string;
  datetime: string | null;
};

export async function fetchGptLogDetail(logId: string): Promise<GptLogDetailPayload> {
  const res = await apiFetch(`/api/v1/ai/gpt-logs/${encodeURIComponent(logId)}`, { method: "GET" });
  if (!res.ok) {
    const raw = await res.text();
    let detail = `gpt_log_failed:${res.status}`;
    try {
      const j = JSON.parse(raw) as { detail?: string };
      if (j.detail) detail = j.detail;
    } catch {
      /* ignore */
    }
    throw new ApiRequestError(detail, res.status, raw);
  }
  return (await res.json()) as GptLogDetailPayload;
}
